import { observer } from 'mobx-react-lite';
import { Tooltip } from 'antd';

const CustomTooltip = observer(({ label, children, styles, placement }) => {
    return (
        <Tooltip
            title={label}
            placement={placement || 'bottom'}
            arrow={false}
            styles={{
                body: {
                    background: '#ffffff',
                    border: '1px solid rgb(0, 0, 0, 0.12)',
                    boxShadow: 'none',
                    color: '#000000',
                    fontSize: '14px',
                    fontWeight: '400',
                    padding: '8px 14px',
                    textAlign: 'center',
                    display: 'flex',
                    alignItems: 'center',
                    width: 'auto',
                    ...styles,
                },
            }}>
            <span className="inline-block">{children}</span>
        </Tooltip>
    );
});

export default CustomTooltip;
